const Roles = {
    management : "UPPER_MANAGEMENT", 
    hod : "HOD",
    member : "FACULTY",
}

export default Roles ;